<script>
import AgacMenu from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import {
  GenericComputed,
  MethodsStrGet,
  MethodsStrPost,
  MethodsStrPut,
  MethodsStrDelete,
  MethodsStrFilterGet,
} from "@/state/helpers";

export default {
  components: {
    AgacMenu,
  },
  props: [
    "multiple",
    "personel_id",
    "BirimTipId",
    "title",
    "title_class",
    "sutun",
    "selected",
    "closeOnSelect",
  ],
  data: () => ({
    value: [],
    children: [],
    options: [],
    birimlist: [],
    veri: [],
    clearable: true,
    searchable: true,
    disabled: false,
    openOnClick: true,
    openOnFocus: false,
    clearOnSelect: true,
    alwaysOpen: false,
    appendToBody: false,
    sortValueBy: "ORDER_SELECTED", //LEVEL , INDEX
    valueConsistsOf: "ALL", // "BRANCH_PRIORITY", "LEAF_PRIORITY","ALL_WITH_INDETERMINATE"
    rtl: false,
    flat: false,
    limit: 0,
    Page: {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1",
    },
  }),
  methods: {
    ...MethodsStrGet,
    ...MethodsStrPost,
    ...MethodsStrPut,
    ...MethodsStrDelete,
    ...MethodsStrFilterGet,

    Get() {

    },
    BirimYukle() {
      for (var i = 0; i < this.birimlist.length; i++) {
        this.veri.push({
          id: this.birimlist[i].Id,
          BirimAdi: this.birimlist[i].BirimAdi,
          UstBirimId: this.birimlist[i].UstBirimId,
        });
      }

      this.options = [];
      this.children = [];

      for (var s = 0; s < this.veri.length; s++) {
        if (this.veri[s].UstBirimId == null) {
          this.options.push({
            id: this.veri[s].id,
            label: this.veri[s].BirimAdi,
            children: null,
          });
        }
      }

      for (var a = 0; a < this.options.length; a++) {
        let cocuk1 = [];
        for (var b = 0; b < this.veri.length; b++) {
          if (
            this.options[a].id == this.veri[b].UstBirimId &&
            this.veri[b].UstBirimId != null
          ) {
            cocuk1.push({
              id: this.veri[b].id,
              label: this.veri[b].BirimAdi,
              children: null,
            });
          }
        }

        if (cocuk1.length > 0) {
          this.options[a].children = cocuk1;

          for (var c = 0; c < this.options[a].children.length; c++) {
              let cocuk2 = [];

              for (var d = 0; d < this.veri.length; d++) {
                if (
                  this.options[a].children[c].id == this.veri[d].UstBirimId &&
                  this.veri[d].UstBirimId != null
                ) {
                  cocuk2.push({
                    id: this.veri[d].id,
                    label: this.veri[d].BirimAdi,
                    children: null,
                  });
                }
              }
              if (cocuk2.length > 0) {
                this.options[a].children[c].children = cocuk2;
                
                    for (var e = 0; e < this.options[a].children[c].children.length; e++) {
                     
                      let cocuk3 = [];
                      
                      for (var f = 0; f < this.veri.length; f++) {
                        if (                   
                          this.options[a].children[c].children[e].id ==  this.veri[f].UstBirimId &&
                          this.veri[f].UstBirimId != null
                        ) {
                          cocuk3.push({
                            id: this.veri[f].id,
                            label: this.veri[f].BirimAdi,
                            children: null,
                          });
                        }
                      }
                      if (cocuk3.length > 0) {
                        this.options[a].children[c].children[e].children = cocuk3;
                       

                            for (var g = 0; g < this.options[a].children[c].children[e].children.length; g++) {
                              let cocuk4 = [];

                              for (var h = 0; h < this.veri.length; h++) {
                                if (
                                  this.options[a].children[c].children[e].children[g].id ==
                                    this.veri[h].UstBirimId &&
                                  this.veri[h].UstBirimId != null
                                ) {
                                  cocuk4.push({
                                    id: this.veri[h].id,
                                    label: this.veri[h].BirimAdi,
                                    children: null,
                                  });
                                }
                              }
                              if (cocuk4.length > 0) {
                                this.options[a].children[c].children[e].children[g].children = cocuk4;


                                        for (var j = 0; j < this.options[a].children[c].children[e].children[g].children.length; j++) {
                                          let cocuk5 = [];

                                          for (var k = 0; k < this.veri.length; k++) {
                                            if (
                                              this.options[a].children[c].children[e].children[g].children[j].id ==
                                                this.veri[k].UstBirimId &&
                                              this.veri[k].UstBirimId != null
                                            ) {
                                              cocuk5.push({
                                                id: this.veri[k].id,
                                                label: this.veri[k].BirimAdi,
                                                children: null,
                                              });
                                            }
                                          }
                                          if (cocuk5.length > 0) {
                                            this.options[a].children[c].children[e].children[g].children[j].children = cocuk5;
                                          } else {
                                            this.options[a].children[c].children[e].children[g].children[j].children = null;
                                          }
                                        }





                              } else {
                                this.options[a].children[c].children[e].children[g].children = null;
                              }
                            }




                      } else {
                        this.options[a].children[c].children[e].children = null;
                      }
                    }
              } else {
                this.options[a].children[c].children = null;
              }
          }
        } else {
          this.options[a].children = null;
        }
      }

      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      tumu[0].children = this.options;
      this.options = tumu;
    },
  },
  computed: {
    ...GenericComputed,
  },
  whatch: {
    selected() {
      this.value = this.selected;
    },
  },
  created() {
    this.Get();

    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };

    this.value = this.selected;

 if (this.personel_id != null) {
      let Filter = "&personel_id=" + this.personel_id;

      this.ActionsFilterGet({Service:"OBirim", Page:this.Page, Filter:Filter}).then((res) => {
        this.birimlist = res.Data;

        this.BirimYukle();
      });
    } else {
      /*this.ActionsGet({"Service":"OBirim", "Page":Page}).then((res) => {
      this.birimlist = res.Data;
      this.BirimYukle();
      }); */

      this.ActionsGet({"Service":"OBirim/GetTree", "Page":Page}).then((res) => {
      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      let silinecek="[]"; 
      let gelen_veri=JSON.stringify(res.Data).replaceAll(silinecek,"");
      silinecek="\"children\":,"
      gelen_veri=gelen_veri.replaceAll(silinecek,"");

      tumu[0].children = JSON.parse(gelen_veri);
      this.options = tumu;    

      });
      
    }
  },
};
</script>
<template>
  <div>
    <b-form-group
      :class="title_class"
      id="gbirimler"
      :label-cols-lg="sutun"
      :label="title"
      label-for="text"
    >
      <AgacMenu
        :multiple="multiple"
        :options="options"
        :flat="false"
        :sort-value-by="sortValueBy"
        :default-expand-level="1"
        placeholder="Birim Seçiniz"
        :clearable="clearable"
        :searchable="searchable"
        :disabled="disabled"
        :open-on-click="openOnClick"
        :open-on-focus="openOnFocus"
        :clear-on-select="clearOnSelect"
        :close-on-select="closeOnSelect"
        :always-open="alwaysOpen"
        :append-to-body="appendToBody"
        :limit="limit"
        :limitText="count => `${count} kayıt secildi`"
        :max-height="200"
        v-model="value"
        :input="$emit('Secilmis_Idler', value)"
        :rtl="rtl"
        :value-consists-of="valueConsistsOf"
      />
      <treeselect-value :value="value" />
    </b-form-group>

  

  </div>

  
</template>
